import { IsNotEmpty, IsOptional, ValidateIf } from 'class-validator';
import { createFromValidationResolver } from '@cp/utils/form';

export class CheckoutFormModel {
  @IsOptional()
  paymentCardId: number;

  @ValidateIf((obj) => {
    return !obj.paymentCardId;
  })
  @IsNotEmpty()
  cryptogram: string;

  @IsNotEmpty()
  tariffId: number;

  @IsNotEmpty()
  successRedirectUrl: string;

  @IsNotEmpty()
  failureRedirectUrl: string;

  @IsOptional()
  promocode?: string;
}

export const checkoutFormResolver = createFromValidationResolver(CheckoutFormModel);
